@if (authError) {
  <app-unauthorised-error-page></app-unauthorised-error-page>
}

@if (!authError) {
  @if (organisationTree != null) {
    <div class="row mb-3">
      <div class="col col-sm-6 col-xl-4">
        <app-organisation-selector [orgTree]="organisationTree!"
          (organisationSelected)="onOrganisationSelected($event)"
        ></app-organisation-selector>
      </div>
    </div>
  }
  <div class="card">
    <div class="card-header d-block py-2">
      <div class="row align-items-center justify-content-between">
        <div class="col col-auto mb-2 mb-sm-0">
          <h3 class="card-title">{{ 'admin.menu.users' | translate }}</h3>
        </div>
        <div class="col col-12 col-sm-auto">
          <div class="row no-gutters">
            <div class="col col-12 col-sm-auto mb-2 mb-sm-0 d-flex align-items-center">
              <label class="form-check form-switch cursor-pointer form-check-inline my-0">
                <input #toggle class="form-check-input cursor-pointer" type="checkbox"
                  [(ngModel)]="onlyActive"
                  (change)="refetchUsersForOrganisation()"
                  >
                  <span class="form-check-label">
                    {{ 'admin.filters.onlyActive' | translate }}
                  </span>
                </label>
                @if (hasImpersonatorRole) {
                  <label
                    class="form-check form-switch cursor-pointer form-check-inline my-0"
                    >
                    <input #toggle class="form-check-input cursor-pointer" type="checkbox"
                      [(ngModel)]="onlyImpersonationRequested"
                      (change)="refetchUsersForOrganisation()"
                      >
                      <span class="form-check-label">
                        {{ 'admin.filters.onlyImpersonationRequested' | translate }}
                      </span>
                    </label>
                  }
                </div>
                <div class="col col-12 col-sm-auto mb-2 mb-sm-0">
                  <app-search-box (searchTermProvided)="onSearchTermProvided($event)"></app-search-box>
                </div>
                <div class="col col-12 col-sm-auto mb-2 mb-sm-0">
                  <lib-export-dropdown [exporting]="exporting"
                    allLabel="admin.export.allUsers"
                    filteredLabel="admin.export.filteredUsers"
                    (exportRequested)="exportUsers($event)"
                  ></lib-export-dropdown>
                </div>
                @if (!readOnly) {
                  <div class="col col-12 col-sm-auto">
                    <button class="btn btn-outline-primary w-100" type="button" (click)="openNewUserModal()">
                      {{ 'admin.newUser' | translate | titlecase }}
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="card-body p-0 overflow-hidden">
          <app-user-data-grid [users]="users" [loading]="loading"
            (editUserClicked)="openEditUserModal($event)"
            (detailsClicked)="openEditUserModal($event, true)"
            [readOnly]="readOnly"
            (toggleUserActiveStatusClicked)="openActivationUserModal($event)"
            (resendInviteClicked)="resendUserInvite($event)"
            (impersonateClicked)="openImpersonationModal($event)"
            (deleteUserClicked)="openDeleteUserModal($event)"
            [searchTerm]="searchTerm"
            [hasImpersonatorRole]="hasImpersonatorRole"
          ></app-user-data-grid>
        </div>
      </div>
    }

    <router-outlet></router-outlet>
